
import * as domainConstants from "../../../constants/DomainConstants";
import voortgangsrapportVerantwoordingApi from "../../../api/voortgangsrapportVerantwoordingApi";
import { uploadOneVoortgangsrapportFile, deleteOneVoortgangsrapportFile } from "../../common/DownloadUploadFilesHelper";

import showToastr, { showToastrError, showToastrInfo, showToastrSuccess } from "../../../util/toastr.js";


import redirector from "../../../util/redirector.js";
import { getStore } from "../../../store/configureStore";

export default class VRVerantwoordingPageHelper {
	constructor(context, redirector) {
		this.dispatch = getStore().dispatch;
		this.context = context;
		this.redirector = redirector;
	}

	init() {
		const { vrLoaded, loadLayout, vrProjectId } = this.context.props;

		if (!vrLoaded)
			redirector.goTo("voortgangsrapport/project/" + vrProjectId);

		if (vrProjectId) {
			this.context.props.ajaxStarted();
			voortgangsrapportVerantwoordingApi.get(vrProjectId).then(response => {
				const vrVerantwoording = response.data.item;
				const errors = response.data.validationResults || {};

				this.context.props.beadsLoaded(vrVerantwoording.beadModels);
				this.context.props.ajaxEnded();


				this.context.setState({
					vrVerantwoording,
					errors
				});

				this.context.props.getContent(vrProjectId, domainConstants.DocumentTab.VRVerantwoording)
					.then(result => {
						if (result.success) {
							this.context.setState(
								{
									documenten: result.data
								});
						} else {
							showToastrError("Laden van de documenten is mislukt");
							throw new Error("getContent load failed"); //Stops promise
						}
					});

				loadLayout(vrProjectId, true);
			}).catch(error => {
				this.context.props.ajaxFailed(error);
				this.context.props.throwException(error);
			});

			this.context.props.getSjablonen(domainConstants.DocumentTab.VRVerantwoording)
				.then(result => {
					if (result.success) {
						this.context.setState(
							{
								sjablonen: result.data
							});
					} else {
						showToastrError("Laden van de sjablonen is mislukt");
						throw new Error("getSjablonen load failed"); //Stops promise
					}
				});
		}
		else
			redirector.goToNotFound();
	}

	onChange(event) {
		const field = event.target.name;
		const vrVerantwoording = this.context.state.vrVerantwoording;
		vrVerantwoording[field] = event.target.value;

		return this.context.setState({
			vrVerantwoording: vrVerantwoording,
			hasUnsavedChanges: true
		});
	}

	onSave() {
		this.context.props.ajaxStarted();

		voortgangsrapportVerantwoordingApi.save(this.context.state.vrVerantwoording, this.context.state.documenten)
			.then((response) => {
				let vrVerantwoording = response.data.item;
				this.context.props.ajaxEnded();
				let result = null;
				if (response.data.concurrencyException) {
					this.context.setState({ vrVerantwoording, errors: response.data.validationResults });
					result = domainConstants.HAS_CONCURRENCY_EXCEPTION;
				} else if (response.data.hasValidationErrors) {
					this.context.setState({ vrVerantwoording, errors: response.data.validationResults });
					result = domainConstants.HAS_VALIDATION_ERRORS;
				} else if (Object.keys(response.data.validationResults).length !== 0) {
					this.context.setState({ vrVerantwoording, errors: response.data.validationResults });
					result = domainConstants.HAS_VALIDATION_ERRORS_SAVED;
				} else {
					this.context.setState({ vrVerantwoording, errors: null });
					result = domainConstants.SUCCESS;
				}

				let isSaved = showToastr(result);

				if (isSaved) {
					this.context.props.loadLayout(this.context.props.vrProjectId, true);
					this.context.props.beadsLoaded(response.data.item.beadModels);
					this.context.setState({
						hasUnsavedChanges: false
					});
				}

				if (this.context.state.fileSessionStarted) {
					showToastrInfo("Verwerken van bestanden. Even geduld");

					this.context.props.endFileSession(domainConstants.DocumentTab.VRVerantwoording, this.context.props.vrProjectId)
						.then(result => {
							if (!result.success) {
								showToastrError(domainConstants.HAS_FILE_EXCEPTION);
								throw new Error("File process failed"); //Stops promise
							} else {
								this.context.setState({ fileSessionStarted: false });
								showToastrSuccess("Verwerken van bestanden gelukt");
							}
						});
				}
			}).catch(error => {
				this.context.props.ajaxFailed(error);
				this.context.props.throwException(error);
			});
	}

	// documentuploadhelpers
	handleFileRequest(component, actionParam, fileProcess) {
		if (!this.context.state.fileSessionStarted) {
			this.context.props.startFileSession(domainConstants.DocumentTab.VRVerantwoording, this.context.props.vrProjectId)
				.then(result => {
					if (!result.success) {
						showToastrError("Verwerken van bestand is mislukt");
						throw new Error("File process failed"); //Stops promise
					} else {
						this.context.setState({ fileSessionStarted: true });
					}
				}).then(() => fileProcess(component, actionParam));
		}
		else
			fileProcess(component, actionParam);
	}

	onDropFiles(component, files) {
		this.handleFileRequest(component, files, () => { files.forEach(file => uploadOneVoortgangsrapportFile(this.context, this.context.props.uploadDocument, this.context.props.vrProjectId, domainConstants.DocumentTab.VRVerantwoording, component, file)); });
	}

	onDeleteFile(component, fileName) {
		this.handleFileRequest(component, fileName, () => { deleteOneVoortgangsrapportFile(this.context, this.context.props.deleteDocument, this.context.props.vrProjectId, domainConstants.DocumentTab.VRVerantwoording, component, fileName); });
	}

	update(nextProps) {
		if (this.context.props.vrProjectId !== nextProps.vrProjectId) {
			this.context.props.getSjablonen(domainConstants.DocumentTab.VRVerantwoording)
				.then(result => {
					if (result.success) {
						this.context.setState(
							{
								sjablonen: result.data
							});
					} else {
						showToastrError("Laden van de sjablonen is mislukt");
						throw new Error("getSjablonen load failed"); //Stops promise
					}
				});
		}
	}
}